import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { PraticaProgressService } from '../services/pratica-progress.service';

@Injectable({
  providedIn: 'root',
})
export class ScoreGuard implements CanActivate {
  private praticaProgressService = inject(PraticaProgressService);
  private router = inject(Router);
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (route.routeConfig?.path === 'score') {
      let url = state.url.split('/');
      url.splice(url.length - 1, 1, 'aml-score');

      if (this.praticaProgressService.selectedPratica?.type === 'FIN') {
        return true;
      } else {
        return this.router.createUrlTree([url.join('/')]);
      }
    } else {
      let url = state.url.split('/');
      url.splice(url.length - 1, 1, 'score');

      if (this.praticaProgressService.selectedPratica?.type === 'AML') {
        return true;
      } else {
        return this.router.createUrlTree([url.join('/')]);
      }
    }
  }
}
